import React from 'react'

interface ContractIconProps extends React.SVGProps<SVGSVGElement> {
	size?: number
}

export const ContractIcon: React.FC<ContractIconProps> = ({
	size = 16,
	...props
}) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path d="M3 3H6V2H2V6H3V3Z" fill="currentColor" />
			<path d="M10 3H13V6H14V2H10V3Z" fill="currentColor" />
			<path d="M3 13H6V14H2V10H3V13Z" fill="currentColor" />
			<path d="M10 13H13V10H14V14H10V13Z" fill="currentColor" />
		</svg>
	)
}
